import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import CartDrawer from "@/components/layout/CartDrawer";
import CookieBanner from "@/components/layout/CookieBanner";
import api from "@/lib/api";

export default function Layout() {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    api.get("/settings").then(({ data }) => setSettings(data)).catch(() => {});
  }, []);
  return (
    <div className="min-h-screen flex flex-col bg-[#0A0A0B]">
      <Header announcement={settings.announcement} />
      <main className="flex-1">
        <Outlet context={{ settings }} />
      </main>
      <Footer settings={settings} />
      <CartDrawer />
      <CookieBanner />
    </div>
  );
}
